<template>
    <div>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">HRIS Account</h1>
        <p class="text-xs text-[#747474] mt-2">Home / HRIS Account</p>
    </div>
    <div class="mt-7">
        <div class="flex items-center gap-5 mb-5">
            <h1 class="text-[#24723b] font-semibold text-lg">Search / Edit HRIS Portal</h1>
            <button v-on:click="EnabledAdd" class="bg-[#24723b] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add HRIS Account</button>
        </div>
        <div  class="papsi-container h-[300px]overflow-auto mt-3">
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="true" @EditButton="EditButton" @DeleteButton="DeleteButton"  />
            </div>
        </div>
    </div>
    
    <div v-if="adminModal">
        <div @click="adminModal = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#12760A] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Employee Name</p>
                    <SelectionControl v-if="disabled_edit == false" @getEmpKey="getEmpKey" :suggestions="$store.state.emp_info"/>
                    <select v-else class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="employee_id" :disabled="disabled_edit">
                        <option value="" selected disabled>Select Employee Name</option>
                        <option v-for="(info,index) in $store.state.emp_info" :key="index" :value="info.key">{{ info.value }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Username</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Enter Username" @input="username = username.toUpperCase()" v-model="username">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Password</p>
                    <div class="relative">
                        <input class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" :type="ShowPassword" placeholder="Password" v-model="password" @input="valPassword()">
                    <button class="absolute right-5 top-2.5" @click="Showpass">
                        <div v-if="ShowPassword == 'password'">
                            <ClosePassword/>
                        </div>
                        <div v-else>
                            <Showpassword/>
                        </div>
                    </button>
                    </div>

                     <p class="text text-[#adacac] text-xs mt-1">Password Requirements</p>
                     <div class="validation-results px-3">
                          <p :class="{'valid': isLengthValid, 'invalid': !isLengthValid}">
                            ✓ Minimum length: 8 characters
                          </p>
                          <p :class="{'valid': hasUppercase, 'invalid': !hasUppercase}">
                            ✓ Contains uppercase letter
                          </p>
                          <p :class="{'valid': hasLowercase, 'invalid': !hasLowercase}">
                            ✓ Contains lowercase letter
                          </p>
                          <p :class="{'valid': hasNumber, 'invalid': !hasNumber}">
                            ✓ Contains a number
                          </p>
                          <p :class="{'valid': hasSpecialChar, 'invalid': !hasSpecialChar}">
                            ✓ Contains special character
                          </p>
                        </div>
                    <p class="text text-[#adacac] text-xs mt-1">Permission</p>
                    <div class="flex py-3 ">
                        <div class="flex flex-col w-[50%] px-5 gap-1 ">
                            <label class="text-sm">
                                <input type="checkbox" name="ANNOUCEMENT"               v-model="ancAccess">
                                    Announcement
                            </label>
                            <label class="text-sm">
                                <input type="checkbox" name="Form-Signatory"            v-model="optAccess"/>
                                    Option Modification
                            </label>
                            <label class="text-sm">
                                <input type="checkbox" name="Form Signatory"            v-model="signAccess"/>
                                    Form Signatory
                            </label>
                            <label class="text-sm">
                                <input type="checkbox" name="Form Request"              v-model="reqAccess"/>
                                    Form Request
                            </label>
                        </div>
                        <div class="flex flex-col w-[50%] px-5 gap-1 ">
                            <label class="text-sm">
                                <input type="checkbox" name="Employee Profile"          v-model="empAccess"/>
                                    Employee Profile
                            </label>
                            <label class="text-sm">
                                <input type="checkbox" name="Employee Payslip"          v-model="payAccess"/>
                                    Employee Payslip
                            </label>
                            <label class="text-sm">
                                <input type="checkbox" name="Personnel Services"        v-model="servAccess"/>
                                    Personnel Services
                            </label>
                            <label class="text-sm">
                                <input type="checkbox" name="Policies and Procedures"   v-model="poliAccess"/>
                                    Policies and Procedures
                            </label>
                        </div>
                    </div>
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button :class="{' bg-[#999797] text-white': disabledvalue === true}" class="text-sm text-white bg-[#12760A] py-1.5 rounded-md w-[100px]"  v-if="EditorAdd === 'Edit'" v-on:click="UpdateAccount" :disabled="disabledvalue">Update</button>
                <button :class="{' bg-[#999797] text-white': disabledvalue === true}" class="text-sm text-white bg-[#12760A] py-1.5  rounded-md w-[100px] text-center"  v-if="EditorAdd === 'Create'"  v-on:click="createAccount" :disabled="disabledvalue">Create</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px]" v-on:click="adminModal = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    <ValidationPrompt v-if="validation" @yes="confirmedDelete" @cancel="validation = false" :header="promtHead" :header1="promtBody" />

    <div v-if="SuccessfullyCreated">
        <Prompt type="SUCCESCREATEADMINACC" @close="SuccessfullyCreated = false"/>
    </div>
    <div v-if="Validation">
        <Prompt :type="validationType" @close="Validation = false"/>
    </div>

    <div v-if="Delete">
        <Prompt type="DELETE" @close="Delete = false"/>
    </div>
        </div>

</template>
<script>
import Showpassword from "../icons/ShowPassword.vue"
import ClosePassword from "../icons/ClosePassword.vue"
import Services from "../../services/admin"
import TableControl from "../controls/TableControl/TableControl.vue"
import Prompt from "../controls/Prompt/RequestPromt.vue"
import SelectionControl from '../../components/selection/SelectionControl.vue'
import ValidationPrompt from "./Prompt/ValidationPrompt.vue"
import { defineComponent } from "vue";

export default defineComponent({
    components:{
        TableControl,
        Showpassword,
        Prompt,
        SelectionControl,
        ClosePassword,
        ValidationPrompt,
        
    },
    data(){
        return{
            promptHead: null,
            promptBody: null,
            validation : false,
            isLengthValid: false,
            hasUppercase: false,
            hasLowercase: false,
            hasNumber: false,
            hasSpecialChar: false,
            isValidPassword: false,
            disabledvalue: true,
            validationType:"VALIDATION",
            accAccess:      false,
            ancAccess:      false,
            optAccess:      false,
            signAccess:     false,
            reqAccess:      false,
            empAccess:      false,
            payAccess:      false,
            servAccess:     false,
            poliAccess:     false,
            disabled_edit:  false,
            type:'',
            Delete: false,
            SuccessfullyCreated: false,
            info:'',
            Validation: false,
            ViewTable: 'Add Admin',
            header:[
                {title:'Employee ID'},
                {title:'Employee Name'},
                {title:'Username'},
                {title:'Position'},
                {title:'Action'},
            ],
            column:[
                'emp_key',
                'employee_name',
                'username',
                'position',
            ],
            EditorAdd:              '',
            ShowPassword:   'password',
            adminModal:          false,
            GetName:              null,
            employee_id:            '',
            username:               '',
            password:               '',
            message:                '',
        }
     
    },
    mounted(){
        this.getAdminAccount()
        this.employeeWithPosition()
    },
    methods: {
        getEmpKey(key){
            this.employee_id = key
        },
        async getAdminAccount(){
            this.$emit("showLoader")
            const success    =  await Services.getAdminAccount()
            this.info     =  success.data
            this.$emit("hideLoader")
        },
        async employeeWithPosition(){
            this.$emit("showLoader")
            const success    =  await Services.employeeWithPosition()
            this.GetName     =  success.data
            this.$emit("hideLoader")
        },
        EnabledAdd(){
            this.type = "ADD ADMIN ACCOUNT"
            this.EditorAdd      = 'Create'
            this.username       = ''
            this.password       = ''
            this.employee_id    = ''
            this.accAccess=    false,
            this.ancAccess=      false,
            this.optAccess=     false,
            this.signAccess=    false,
            this.reqAccess=      false,
            this.empAccess=      false,
            this.payAccess=     false,
            this.servAccess=     false,
            this.poliAccess=    false,
            this.adminModal     = true
            this.disabled_edit = false
        },
        async createAccount(){
            this.$emit("showLoader")

            if(!this.username || !this.password || !this.employee_id){
                this.$emit("hideLoader")
                this.Validation = true
                return
            }
            if(this.accAccess){
                var accAccess = '1'
            }
            else{
                accAccess = '0'
            }
            if(this.ancAccess){
                var ancAccess = '1'
            }
            else{
                 ancAccess = '0'
            }
              
            if(this.optAccess){
                var optAccess = '1'
            }
            else{
                 optAccess = '0'
            }
            if(this.signAccess){
                var signAccess = '1'
            }
            else{
                 signAccess = '0'
            }
            if(this.reqAccess){
                var reqAccess = '1'
            }
            else{
                 reqAccess = '0'
            }
            if(this.empAccess){
                var empAccess = '1'
            }
            else{
                empAccess = '0'
            }
            if(this.payAccess){
                var payAccess = '1'
            }
            else
                 payAccess = '0'

            if(this.servAccess){
                var servAccess = '1'
            }
            else
                 servAccess = '0'

            if(this.poliAccess){
                var poliAccess = '1'
            }
            else{
                 poliAccess = '0'
            }
            //   signAccess reqAccess emptAccess payAccess servAccess poliAccess
            this.disabledvalue = true
            const success    =  await Services.addAdminAccount(this.username,this.password,this.employee_id,accAccess,ancAccess,optAccess,signAccess,reqAccess,empAccess,payAccess,servAccess,poliAccess)
            this.message     =  success.success
            if(success.success == true){
                this.adminModal = false
                this.SuccessfullyCreated = true
                this.getAdminAccount()
            }
            else{
                if(success.message =="Username is already exists."){
                    this.validationType = "ALREADYUSER"
                    this.Validation = true
                }
                else if(success.message =="You have already created an account."){
                    this.validationType = "ALREADYACCOUNT"
                    this.Validation = true
                }
                else{
                    this.validationType = "VALIDATION"
                    this.Validation = true
                }
               
            }
            this.disabledvalue = false
            this.$emit("hideLoader")
        },
        Showpass(){
            if(this.ShowPassword == 'password'){
                this.ShowPassword = 'text'
            }
            else{
                this.ShowPassword = 'password'
            }
        },
        async confirmedDelete(){
            this.$emit("showLoader")
            await Services.deleteAdminAccount(this.EditID )
            await this.getAdminAccount()
            this.validation = false
            this.Delete = true
            this.$emit("hideLoader")
        },
        DeleteButton(row)
        {
            this.EditID         = row.emp_key
            this.promtHead      = "DELETE ADMIN"
            this.promtBody      = "Are you sure you want to remove this administrator account?"
            this.validation     = true
        },
        async EditButton(row){

            this.$emit("showLoader")
            const success = await Services.verifyModule(row.emp_key)
           
            this.accAccess  =    success.data.hrisModule,
            this.ancAccess  =    success.data.ancModule,
            this.optAccess  =    success.data.optModule,
            this.signAccess =    success.data.sigModule,
            this.reqAccess  =    success.data.reqModule,
            this.empAccess  =    success.data.profModule,
            this.payAccess  =    success.data.payModule,
            this.servAccess =    success.data.perModule,
            this.poliAccess =    success.data.polModule,
         
            this.type = "UPDATE ADMIN ACCOUNT"
            this.EditID         =    row.id
            this.username       =    row.username
            this.password       =    row.password
            this.employee_id    =    row.employee_key
            this.$emit("hideLoader")
            this.adminModal = true
            this.disabled_edit = true
            this.EditorAdd = 'Edit'
    

        },
        async UpdateAccount(){
            this.$emit("showLoader")
            if(this.accAccess){
                var accAccess = '1'
            }
            else{
                accAccess = '0'
            }
              

            if(this.ancAccess){
                var ancAccess = '1'
            }
            else{
                 ancAccess = '0'
            }
              
            if(this.optAccess){
                var optAccess = '1'
            }
            else{
                 optAccess = '0'
            }
             

            if(this.signAccess){
                var signAccess = '1'
            }
            else{
                 signAccess = '0'
            }
              

            if(this.reqAccess){
                var reqAccess = '1'
            }
            else{
                 reqAccess = '0'
            }
             
            if(this.empAccess){
                var empAccess = '1'
            }
            else{
                empAccess = '0'
            }
            

            if(this.payAccess){
                var payAccess = '1'
            }
            else
                 payAccess = '0'

            if(this.servAccess){
                var servAccess = '1'
            }
            else
                 servAccess = '0'

            if(this.poliAccess){
                var poliAccess = '1'
            }
            else{
                 poliAccess = '0'
            }

            await Services.editAdminAccount(this.EditID,this.username,this.password,this.employee_id,accAccess,ancAccess,optAccess,signAccess,reqAccess,empAccess,payAccess,servAccess,poliAccess)
            this.getAdminAccount()
            this.adminModal = false
            this.$emit("hideLoader")

        },
        valPassword() {
            // Reset the flags before each validation run
            this.isLengthValid    = false;
            this.hasUppercase     = false;
            this.hasLowercase     = false;
            this.hasNumber        = false;
            this.hasSpecialChar   = false;

            const lengthPattern = /.{8,}/;
            const uppercasePattern = /[A-Z]/;
            const lowercasePattern = /[a-z]/;
            const numberPattern = /\d/;
            const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
            const trimmedPassword = this.password.trim();

            this.isLengthValid = lengthPattern.test(trimmedPassword);
            this.hasUppercase = uppercasePattern.test(trimmedPassword);
            this.hasLowercase = lowercasePattern.test(trimmedPassword);
            this.hasNumber = numberPattern.test(trimmedPassword);
            this.hasSpecialChar = specialCharPattern.test(trimmedPassword);

            if(this.isLengthValid && this.hasUppercase && this.hasLowercase  && this.hasNumber && this.hasSpecialChar )
            {
                this.disabledvalue = false
            }
            else
            {
                this.disabledvalue = true
            }
            
        },
    },
});
</script>

<style scoped>

.error{
    border:1px solid red;
}

.errorResult{
 background-color:red;
}

.password-validation {
  max-width: 400px;
  margin: 20px;
}

.validation-results p {

  font-size: 13px;
  color: #d9534f; /* Default red for invalid conditions */
}

.validation-results p.valid {
  color: #07c410; /* Green color for valid conditions */
}

.validation-results p.invalid {
  color: #d9534f; /* Red color for invalid conditions */
}

.error-message {
  color: red;


}

</style>